module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.product.title
    }
  }, [_c('span', {
    staticClass: "badge",
    class: _vm.product.original.variation.status,
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.$t(_vm.product.original.variation.status).label))]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md image"
  }, [_c('img', {
    attrs: {
      "slot": "image",
      "src": _vm.image,
      "alt": _vm.product.title
    },
    slot: "image"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('span', {
    staticClass: "divider"
  }, [_vm._v("Atributos")]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("SKU:")]), _vm._v(" " + _vm._s(_vm._f("attribute")(_vm.product.sku)))]), _vm._v(" "), _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("EAN:")]), _vm._v(" " + _vm._s(_vm._f("attribute")(_vm.product.ean)))]), _vm._v(" "), (_vm.product.brand) ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Marca:")]), _vm._v(" " + _vm._s(_vm.product.brand))]) : _vm._e(), _vm._v(" "), (_vm.product.color) ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Cor:")]), _vm._v(" " + _vm._s(_vm.product.color))]) : _vm._e(), _vm._v(" "), (_vm.product.grid) ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Tamanho:")]), _vm._v(" " + _vm._s(_vm.product.grid))]) : _vm._e(), _vm._v(" "), (_vm.product.flavor) ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Sabor:")]), _vm._v(" " + _vm._s(_vm.product.flavor))]) : _vm._e(), _vm._v(" "), (_vm.product.voltage) ? _c('span', {
    staticClass: "ds-block"
  }, [_c('strong', [_vm._v("Voltagem:")]), _vm._v(" " + _vm._s(_vm.product.voltage))]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24a90696","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/provide/report/Product.vue
// module id = 2986
// module chunks = 0